export function getCookie(name: string): string | undefined {
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || undefined
  );
}

export function removeCookie(name: string) {
  document.cookie = `${name}=;Max-Age=0;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;Secure;${import.meta.env.VITE_DOMAIN ? `domain=${import.meta.env.VITE_DOMAIN};` : ''}`;
}
